require('./blockECardErrorStep.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText, FormattedText } = require('core/i18n').i18n;

const BlockECardErrorStep = props => {
    const { immCard } = props;
    const title = formatText('cardBlock-eCardBlockErrorTitle');
    const cardAlias = immCard.get('alias').get('current');
    const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToDetails
    };
    const linkToDownloadBalance = `/myprofile/cards/${immCard.get('cardId')}/charge`;

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError errorMessage={title} mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        <FormattedText value="cardBlock-eCardBlockWarningMessage" />
                        <OKLink modifier="emphasize" to={linkToDownloadBalance} extraClass="block-ecard__balance-link">
                            <FormattedText value="cardBlock-eCardBlockLinkLabel" />
                        </OKLink>
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

BlockECardErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = BlockECardErrorStep;